import * as angular from "angular";
import { AdminDataProvider } from "../../../data-provider/admin.dp";
import { stripeStatuses } from "../../../utils/constants/stripe.constants";
import { FilterDataProvider } from "../../../data-provider/filter.dp";
import { Filter } from "../../../models/filter.model";
import * as _ from "lodash";
import { SearchUtils } from "../../../helper/search.helper";
import * as $ from "jquery";
import { NavigationBarHelperService } from "../../navigation/navigation-bar.helper";
import { CampaignDataProvider } from "../../../data-provider/campaign.dp";

let AdminFilterPaneComponent = {
    selector: "vcAdminFilterPane",
    templateUrl:
        "/angular/components/admin/filter/admin-filter-pane.component.html",
    controller: class AdminFilterPaneController {
        private readonly $location: any;
        private readonly $scope: any;
        private readonly searchUtils: SearchUtils;
        private readonly navigationBarService: NavigationBarHelperService;

        public readonly stripeStatuses = stripeStatuses;
        public dataProvider: FilterDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        public filter: Filter;
        public appliedFilter: Filter;
        public emptyFilter: Filter;
        public selectedFilter: Filter;
        public firstLoad = true;
        public campaignKinds: any;

        public readonly defaultFilter = new Filter({
            status: { values: [], checked: true },
            stripe: { values: [], checked: true },
            region: { values: [], checked: true },
            search: { values: "", checked: true },
            kind: { values: [], checked: true },
        });

        constructor(
            $scope: any,
            $location: any,
            FilterDataProvider: FilterDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            SearchUtils: SearchUtils
        ) {
            this.$scope = $scope;
            this.dataProvider = FilterDataProvider;
            this.filter = FilterDataProvider.filter;
            this.appliedFilter = FilterDataProvider.appliedFilter;
            this.navigationBarService = NavigationBarHelperService;
            this.campaignDataProvider = CampaignDataProvider;
            this.$location = $location;
            this.searchUtils = SearchUtils;

            _.merge(this.filter, _.cloneDeep(this.defaultFilter));
            this.setFilters(this.defaultFilter);

            this.$scope.$watch(
                () => this.appliedFilter,
                () => {
                    this.dataProvider.nonEmptyAppliedFilters(this.firstLoad);
                    this.searchUtils.searchText = this.appliedFilter.search
                        ? this.appliedFilter.search.values
                        : "";
                    this.$location.search(
                        "filter",
                        JSON.stringify(this.filter.nonEmptyValues())
                    );
                },
                true
            );
            this.campaignDataProvider.getKinds().then((campaignKinds) => {
                this.campaignKinds = campaignKinds;
            });
        }
        setFilters(filters: Filter): void {
            this.emptyFilter = _.cloneDeep(filters);
            this.filter.setData(_.merge(filters, this.previousFilter()));
            _.merge(this.appliedFilter, _.cloneDeep(this.filter));
            this.$location.search(
                "filter",
                JSON.stringify(this.filter.nonEmptyValues())
            );
        }

        previousFilter(filter?: Filter): Filter {
            let search = angular.isDefined(filter)
                ? { filter: filter }
                : this.$location.search();
            return this.dataProvider.reformatFilter(search);
        }

        filterChanged(): boolean {
            return !angular.equals(
                this.filter.nonEmptyValues(),
                this.appliedFilter.nonEmptyValues()
            );
        }

        applyFilters(): void {
            $("#mainDataContainer").scrollTop(0);
            // The chips and toolbar toggles write straight onto appliedFilter
            // and are not part of this pane's draft, so carry them across
            // removeValues() - which would otherwise blank status and turn the
            // booleans into truthy {} objects.
            const keep = _.pick(this.appliedFilter, [
                "status",
                "thisRegion",
                "attached",
                "onlineOnly",
                "accountStatus",
                "platform",
                "ostatus",
                "result",
                "showPresence",
                "sort",
                "sortDir",
                "lens",
                "range",
                "trend",
            ]);
            this.dataProvider.removeValues(this.appliedFilter);
            _.merge(this.appliedFilter, _.cloneDeep(this.filter), keep);
        }

        clearFilters(): void {
            this.selectedFilter = null;
            const search = this.filter.search;

            _.forEach(this.filter, (data: any, key: string) => {
                data.values = null;
            });
            this.filter.setData(_.cloneDeep(this.emptyFilter));
            this.filter.search = search;
            this.applyFilters();
        }

        closeFilterBar(): void {
            this.navigationBarService.setFilterBarOpen(false);
        }

        toggleCatgoryCheckBox(index): void {
            let turnOff = this.isActiveCategoryFilterCheckbox(index);
            for (let sub of this.campaignKinds[index].subcategories) {
                if (turnOff) {
                    if (
                        this.dataProvider.isActiveFilterCheckbox(
                            this.filter,
                            "kind",
                            sub.id,
                            "",
                            ""
                        )
                    ) {
                        this.dataProvider.toggleFilterCheckBox(
                            this.filter,
                            "kind",
                            sub.id,
                            "",
                            ""
                        );
                    }
                } else {
                    if (
                        !this.dataProvider.isActiveFilterCheckbox(
                            this.filter,
                            "kind",
                            sub.id,
                            "",
                            ""
                        )
                    ) {
                        this.dataProvider.toggleFilterCheckBox(
                            this.filter,
                            "kind",
                            sub.id,
                            "",
                            ""
                        );
                    }
                }
            }
        }

        isActiveCategoryFilterCheckbox(index): boolean {
            let active: boolean = true;
            for (let sub of this.campaignKinds[index].subcategories) {
                active =
                    active &&
                    this.dataProvider.isActiveFilterCheckbox(
                        this.filter,
                        "kind",
                        sub.id,
                        "",
                        ""
                    );
            }
            return active;
        }
    },
};

angular
    .module("admin")
    .component(AdminFilterPaneComponent.selector, AdminFilterPaneComponent);
